export const DEFAULT_BRANDING_PRIMARY_COLOR = "#7F56D9";
export const DEFAULT_BRANDING_LOGO =
  "https://3nahrfk4mnfktf1o.public.blob.vercel-storage.com/media-upload-4x76MaLpz6PW9bc8YHHwu8Ajol32Ae.png";
export const DEFAULT_BRANDING_FONT = "";
